// GroomingPreference.jsx
import React from 'react';

// Dog prefs (your existing files)
import NailPreferences from './NailPreferences';
import BathPreferences from './BathPreferences';
import TouchUpPreferences from './TouchUpPreferences';
import GroomingPreferences from './GroomingPreferences';
import TeethPreferences from './TeethPreferences';

// Cat prefs (new files below)
import CatNailPreferences from './CatNailPreferences';
import CatBathPreferences from './CatBathPreferences';
import CatTouchUpPreferences from './CatTouchUpPreferences';
import CatGroomingPreferences from './CatGroomingPreferences';

const GroomingPreference = ({ groomingBookingData, setGroomingBookingData }) => {
  // determine species from selection
  var petType = 'Dog';
  if (groomingBookingData &&
      groomingBookingData.selectedPets &&
      groomingBookingData.selectedPets.length > 0 &&
      groomingBookingData.selectedPets[0] &&
      groomingBookingData.selectedPets[0].petType) {
    petType = groomingBookingData.selectedPets[0].petType;
  }

  var pkg = '';
  if (groomingBookingData &&
      groomingBookingData.groomingOptions &&
      groomingBookingData.groomingOptions.selectedPackage) {
    pkg = groomingBookingData.groomingOptions.selectedPackage;
  }

  var isCat = petType === 'Cat';

  // Cats have no "teeth" package
  if (isCat && pkg === 'teeth') {
    return null;
  }

  if (isCat) {
    if (pkg === 'nail') {
      return <CatNailPreferences
        groomingBookingData={groomingBookingData}
        setGroomingBookingData={setGroomingBookingData}
      />;
    }
    if (pkg === 'bath') {
      return <CatBathPreferences
        groomingBookingData={groomingBookingData}
        setGroomingBookingData={setGroomingBookingData}
      />;
    }
    if (pkg === 'touchup') {
      return <CatTouchUpPreferences
        groomingBookingData={groomingBookingData}
        setGroomingBookingData={setGroomingBookingData}
      />;
    }
    if (pkg === 'grooming') {
      return <CatGroomingPreferences
        groomingBookingData={groomingBookingData}
        setGroomingBookingData={setGroomingBookingData}
      />;
    }
    return null;
  }

  // Dog routes (unchanged)
  if (pkg === 'nail') {
    return <NailPreferences
      groomingBookingData={groomingBookingData}
      setGroomingBookingData={setGroomingBookingData}
    />;
  }
  if (pkg === 'bath') {
    return <BathPreferences
      groomingBookingData={groomingBookingData}
      setGroomingBookingData={setGroomingBookingData}
    />;
  }
  if (pkg === 'touchup') {
    return <TouchUpPreferences
      groomingBookingData={groomingBookingData}
      setGroomingBookingData={setGroomingBookingData}
    />;
  }
  if (pkg === 'grooming') {
    return <GroomingPreferences
      groomingBookingData={groomingBookingData}
      setGroomingBookingData={setGroomingBookingData}
    />;
  }
  if (pkg === 'teeth') {
    return <TeethPreferences
      groomingBookingData={groomingBookingData}
      setGroomingBookingData={setGroomingBookingData}
    />;
  }

  return null;
};

export default GroomingPreference;
